export enum ColorStyles {
    DEFAULT = 'default',
    PLAYER_COLOR = 'playerColor',
}
